import { Button } from 'antd';
import React from 'react';
import { InfraredRayCommand } from '../../Device/Simulator/InfraredRay';

export const ScreenConfig = (props) => {
    const { onClose, masterDevice } = props;

    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            margin: '10px'
        }}>
            <Button onClick={() => {
                masterDevice.sendInfraredRayCommand(InfraredRayCommand.ScreenDevicePowerOn);
                onClose();
            }}>下拉投影幕布</Button>
            <Button onClick={() => {
                masterDevice.sendInfraredRayCommand(InfraredRayCommand.ScreenDevicePowerOff);
                onClose();
            }}>收起投影幕布</Button>
        </div>
    );
};
